import Api from '@/services/Index';

const store = async (data) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT;

    if (data.id) {
        return Api.put('/board/decisions/' + data.id, data);
    }
    return Api.post('/board/decisions', data);
}

const get = async (id) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT;
    return Api.get('/board/decisions/' + id);
}

const getAll = async (config) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT;
    return Api.get('/board/decisions', config);
}

const createDocument = async (id, data) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT;
    return Api.post('/board/decisions/document/' + id, data, {responseType: 'arraybuffer'});
}

export default {
    store,
    get,
    getAll,
    createDocument
}
